import React, { useEffect, useState } from 'react';
import './index.scss';
import { IInvoiceItem } from '../../invoice/type';
import { message } from 'antd';
import { deleteBill, setDefaultBill } from '@/api/personal-center';
import InvoiceModal from '../../invoice/components/add-modal';
import DeleteModal from '../delete-modal';

interface Props extends IInvoiceItem {
  refreshInvoiceList: () => void;
  onClick: (id: number) => void;
  invoiceId?: number;
}

const InvoiceCell = (props: Props) => {
  const dict = [
    { value: 1, label: '数电普通发票' },
    { value: 2, label: '数电普通发票' },
    { value: 3, label: '数电专用发票' },
  ];

  const filterLabel = (value: number, list: { value: number; label: string }[]) => {
    const res = list.find((v) => v.value === value);
    return res ? res.label : '';
  };

  const [showAddModal, setShowAddModal] = React.useState(false);
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [invoiceItem, setInvoiceItem] = useState<IInvoiceItem | null>();
  const [selectId, setSelectId] = useState<number>();

  useEffect(() => {
    props.refreshInvoiceList();
  }, [showAddModal, showDeleteModal]);
  const handleEdit = (obj: IInvoiceItem) => {
    setShowAddModal(true);
    setInvoiceItem(obj);
  };
  const handleDeletes = (id: number) => {
    setInvoiceItem(null);
    setShowDeleteModal(true);
    setSelectId(id);
  };

  // const handleAddInvoice = () => {
  //   if (invoiceData.length > 10 || invoiceData.length === 10) {
  //     message.error('发票抬头最多添加10个');
  //     return false;
  //   }
  //   setInvoiceItem(null);
  //   setShowAddModal(true);
  // };

  const handleDefaultBill = (id: number) => {
    setDefaultBill(id).then((res: any) => {
      if (res.success) {
        message.success('操作成功');
        props?.refreshInvoiceList();
      } else {
        message.error(res.message);
      }
    });
  };

  // const handleInvoiceData = () => {
  //   getBillBaseList().then((res: any) => {
  //     if (res?.success) {
  //       setInvoiceData(res.obj);
  //     } else {
  //       message.error(res.message);
  //     }
  //   });
  // };

  const haddleDeleteCard = () => {
    if (selectId) {
      deleteBill(selectId).then((res: any) => {
        if (res.success) {
          message.success('删除成功');
          setShowDeleteModal(false);
          props?.refreshInvoiceList();
        } else {
          message.error(res.message);
        }
      });
    }
  };

  return (
    <div className="invoice-cell-wrap">
      <div className={`invoice-cell ${props.invoiceId === props.id && 'active'}`} onClick={() => props.onClick(props.id)}>
        <div className="line1">
          <div className="line1-left">
            <span>{filterLabel(props.type, dict)}</span>
            <span>{props.header}</span>
            <span>{props.code}</span>
            {props.defaultStatus === 1 && <span>默认</span>}
          </div>
          <div className="line1-right">
            {!props.defaultStatus && <span onClick={() => handleDefaultBill(props.id)}>设为默认发票抬头</span>}
            <span onClick={() => handleEdit(props)}>修改</span>
            <span onClick={() => handleDeletes(props.id)}>删除</span>
          </div>
        </div>
      </div>
      <InvoiceModal showModal={showAddModal} setShowAddModal={setShowAddModal} invoiceItem={invoiceItem ?? {}} />
      <DeleteModal showDeleteModal={showDeleteModal} setShowDeleteModal={setShowDeleteModal} handleDelete={haddleDeleteCard} title="删除提醒" content="请确认是否删除该发票？" />
    </div>
  );
};

export default InvoiceCell;
